import { Button } from '@/_shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/_shared/components/ui/dialog';

interface DeleteTokenDialogProps {
  token: { tokenHash: string; name: string } | null;
  onOpenChange: (open: boolean) => void;
  isDeleting: boolean;
  onConfirm: (tokenHash: string) => void;
}

export function DeleteTokenDialog({
  token,
  onOpenChange,
  isDeleting,
  onConfirm,
}: DeleteTokenDialogProps): React.ReactElement {
  return (
    <Dialog
      open={token !== null}
      onOpenChange={(open) => {
        if (!open && !isDeleting) onOpenChange(false);
      }}
    >
      <DialogContent
        onEscapeKeyDown={(event) => {
          if (isDeleting) event.preventDefault();
        }}
        onInteractOutside={(event) => {
          if (isDeleting) event.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle>Delete access token</DialogTitle>
          <DialogDescription>
            {token
              ? `${token.name} will stop working immediately. Any scripts or integrations using it will lose access.`
              : ''}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="secondary"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
            label="Cancel"
          />
          <Button
            type="button"
            variant="primary-destructive"
            loading={isDeleting}
            onClick={() => token && onConfirm(token.tokenHash)}
            label="Delete"
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
